import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';

const CHART_ID = 'energy_burden_distribution_summary_statistics';

export type LeadBurdenFacts = {
  locationName: string;
  year: number;
  framework: string;
  incomeBand: string;
  /** energy_burden_pct_income — modeled share of household income spent on home energy */
  burdenPct: number | null;
  totalEnergyCost: number | null;
  totalIncome: number | null;
  householdUnits: number | null;
  peerPercentile: number | null;
};

export const LEAD_BURDEN_DEFINITION =
  'Energy burden is estimated annual home energy cost divided by estimated annual household income (U.S. DOE LEAD Tool modeled household characteristics—not individual utility bills).';

export function buildLeadBurdenTokens(facts: LeadBurdenFacts): Record<string, string> {
  const burdenValue =
    facts.burdenPct != null && Number.isFinite(facts.burdenPct) ? facts.burdenPct.toFixed(2) : '—';
  const groupLabel = `${facts.framework} ${facts.incomeBand}`;
  const comparisonSentence =
    facts.peerPercentile != null
      ? ` Relative to peer places in the same framework, this burden ranks near the ${facts.peerPercentile.toFixed(0)}th percentile.`
      : '';
  const highBurdenSentence =
    facts.burdenPct != null && facts.burdenPct >= 6
      ? ' This income band meets a commonly cited high-burden threshold (6% or more of income).'
      : '';

  return {
    locationName: facts.locationName,
    burdenValue,
    groupLabel,
    comparisonSentence,
    highBurdenSentence,
    year: String(facts.year),
    householdCount:
      facts.householdUnits != null ? facts.householdUnits.toLocaleString() : '—',
  };
}

export function buildLeadBurdenAuthoredBundle(facts: LeadBurdenFacts) {
  const tokens = buildLeadBurdenTokens(facts);
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, 'default', tokens);
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}

export function leadBurdenOverviewDescription(fallback: string): string {
  return getAuthoredOverview(CHART_ID, 'default', fallback);
}
